import { CardHeader, CardTitle } from "@b2b/ui-components";

const RegistrationHeader = () => (
    <CardHeader className="text-center space-y-4 pb-8">
        <CardTitle className="text-3xl font-bold text-gray-900">
            Create Your Business Account
        </CardTitle>
        <p className="text-gray-600 text-lg">
            Join millions of businesses trading globally with confidence
        </p>
    </CardHeader>
);

export default RegistrationHeader;
